/**
 * @module app.portal.userCtrl
 *
 * The var names witch contain loading mean : is a request pending ?
 */

define(['angular', 'lodash'], function(angular, _) {

    function UserCtrl($scope, $rootScope, $uibModal, $log, authService, userService, Notification) {
        authService.updateLoginStatus(); // on verifie que le token est toujours là
        let self = {};
        self.dt = $('#table');

        self.roles = [
            { id: 'DRV', label: 'DRV' },
            { id: 'RDS', label: 'RDS' },
            { id: 'CUP', label: 'CUP' },
            { id: 'CS', label: 'CS' },
            { id: 'TELEPRO', label: 'TELEPRO' },
            { id: 'DC', label: 'DC' },
            { id: 'RESP TELEPRO', label: 'RESP TELEPRO' },
            { id: 'AC', label: 'AC' },
            { id: 'ANCIEN_RDS', label: 'ANCIEN_RDS' },
            { id: 'CSD', label: 'CSD' },
            { id: 'RESP CSD', label: 'RESP CSD' },
        ];

        self.columns = [
            {
                data: 'uid',
                title: 'Identifiant LDAP'
            },
            {
                data: 'firstname',
                title: 'Prénom'
            },
            {
                data: 'lastname',
                title: 'Nom'
            },
            {
                data: 'displayName',
                title: 'Nom affiché'
            },
            {
                data: 'role',
                title: 'Rôle'
            },
            {
                data: 'parent',
                title: 'Manager',
                render: function(data) {
                    const user = userService.findPerson(data);
                    return user ? user.user.displayName : data;
                }
            },
            {
                data: 'teleproUid',
                title: 'Télépro',
                render: function(data) {
                    const user = userService.findPerson(data);
                    return user ? user.user.displayName : data;
                }
            },
            {
                data: 'csUid',
                title: 'CS',
                render: function(data) {
                    const user = userService.findPerson(data);
                    return user ? user.user.displayName : data;
                }
            },
            {
                data: 'matricule',
                title: 'Matricule'
            }
        ];

        self.prepareUpdate = function(uid) {
            self.userToUpdate = uid;
            _openModalUpdateUser();
        };

        function _openModalUpdateUser(size) {
            let _updateUserModal = $uibModal.open({
                animation: true,
                templateUrl: 'updateUser.html',
                controller: 'UpdateUserCtrl',
                controllerAs: 'updateUserCtrl',
                size: size,
                resolve: {
                    user: function() {
                        return self.users.filter(user => user.uid === self.userToUpdate);
                    },
                    roles: function() {
                        return self.roles;
                    },
                    users: function() {
                        return self.users;
                    }
                }
            });
            _updateUserModal.result.then(function(data) {
                _confirmUpdate(data.user);
            });
        }

        function _confirmUpdate(user) {
            for (let i = 0; i < self.users.length; i++) {
                if (self.users[i].uid === self.userToUpdate) {
                    self.users[i] = user;
                    userService
                        .createOrUpdateUser(self.users[i])
                        .then(function() {
                            self.table.clear().draw();
                            self.table.rows.add(self.users).draw();
                            Notification.success('Utilisateur mis à jour.');
                        })
                        .catch(function(err) {
                            Notification.error('Une erreur est survenue: ' + err);
                            $log.error(err);
                        });
                    break;
                }
            }
        }

        function _getUser() {
            userService.getUsers().then(res => {
                self.users = res;
                self.table = _initDt(self.columns, res);
            });
        }

        function _initDt(cols, content) {
            const columns = _.cloneDeep(cols);
            const data = _.cloneDeep(content);

            const dtOptions = {
                data,
                columns,
                info: false,
                filter: true,
                retrieve: true,
                deferRender: true,
                buttons: ['searchBuilder', 'savedStatesCreate', 'colvis'],
                language: {
                    url: 'https://cdn.datatables.net/plug-ins/1.13.8/i18n/fr-FR.json',
                },
                paging: false,
                order: [[0, 'asc']],
                select: {
                    style: 'api',
                    toggleable: false
                },
                dom: 'Bft',
                initComplete: () => {
                    $scope.$emit('initComplete', self.table);

                    self.dt.on('click', 'tr', function() {
                        const row = $scope.userCtrl.table.row(this).data();
                        if (row) {
                            self.prepareUpdate(row.uid);
                        }
                    });
                }
            };
            return self.dt.DataTable(dtOptions);
        }

        _getUser();

        return self;
    }

    UserCtrl.$inject = ['$scope', '$rootScope', '$uibModal', '$log', 'authService', 'userService', 'Notification'];

    angular.module('app.portal.userCtrl', ['ui-notification']).controller('UserCtrl', UserCtrl);
});
